import styles from "./StyleModule.module.css";

export default function StyleModule() {
  return (
    <>
      <h2 className={styles.box}>Module css - 클래스 명 난독화</h2>
    </>
  );
}
